<template>
  <div>
    <div style="margin: auto;" class="pt-3 fit-content">
      <v-layout row wrap>
        <v-flex xs6>
          <date-picker class="margin: auto pt-4" month :selected-month="selectedMonth" @onDateUpdate="d => selectedMonth = d" />
        </v-flex>
        <v-flex xs6>
          <v-radio-group v-model="reportIntervalType" class="pl-4" :mandatory="false">
            <v-radio
              v-for="intType in intervalTypes"
              :key="intType.value"
              color="primary"
              :label="$t(intType.label)"
              :value="intType.value"
            />
          </v-radio-group>
        </v-flex>
      </v-layout>
    </div>
    <v-flex
      xs12
      lg10
      xl8
      style="margin: auto;"
      class="pb-5 px-2"
    >
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline">
            <span>
              {{ $t('ordersHistoryContainer.expensesFor', { month: currentmonth }) }}
            </span>
          </h3>
        </v-card-title>
        <v-data-table
          :rows-per-page-text="$t('dataTables.rowsPerPage')"
          :no-data-text="$t('dataTables.noData')"
          :loading="loading > 0"
          :headers="headers"
          hide-actions
          :items="requests"
          class="elevation-1"
          :rows-per-page-items="rowsPerPage"
          item-key="name"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">{{ `${props.item.date} (${getDayOfWeek(props.item.date)})` }}</td>
              <td class="text-xs-left">{{ cities.find(x => x.id === props.item.day.cityId).name }}</td>
              <td class="text-xs-left">{{ getSoups(props.item.dishes) }}</td>
              <td class="text-xs-left">{{ getMains(props.item.dishes) }}</td>
              <td class="text-xs-right">{{ props.item.paidPrice.toFixed(2) }}€</td>
            </tr>
          </template>
          <template slot="footer">
            <td colspan="100%" style="text-align: right; padding: 0 24px;">
              <div><strong>{{ $t('ordersHistoryContainer.totalCost', { total: totalCost.toFixed(2)}) }}</strong></div>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ $t('dataTables.pagingRow', { start: props.pageStart, stop: props.pageStop, length: props.itemsLength }) }}
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';
import gql from 'graphql-tag';
import NotificationService from '@/services/NotificationService';
import ErrorHandler from '@/services/ErrorHandler';
import DatePicker from '../common/date-picker/DatePicker.vue';

export default {
  name: 'OrdersHistoryContainer',
  components: {
    'date-picker': DatePicker,
  },
  data() {
    return {
      searchQuery: '',
      loading: 0,
      currentUser: null,
      selectedMonth: this.$route.params.date,
      reportIntervalType: undefined,
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['userData', 'cities']),
    ...mapState('defaultValuesStore', ['intervalTypes']),
    currentmonth() {
      const month = moment(this.selectedMonth).get('month');
      const translatedMonth = this.$t(`common.forMonth-${month}`);
      return translatedMonth;
    },
    rowsPerPage() {
      return [{ text: this.$t('dataTables.all'), value: -1 }];
    },
    headers() {
      const defaultHeaders = [
        {
          text: this.$t('ordersHistoryContainer.date'), align: 'left', sortable: true, value: 'date',
        },
        {
          text: this.$t('ordersHistoryContainer.city'), value: 'day.cityId', align: 'left', sortable: true,
        },
        {
          text: this.$t('ordersHistoryContainer.soup'), value: 'soup', align: 'left', sortable: false,
        },
        {
          text: this.$t('ordersHistoryContainer.mainDish'), value: 'mainDish', align: 'left', sortable: false,
        },
        {
          text: this.$t('ordersHistoryContainer.paidPrice'), value: 'paidPrice', align: 'right', sortable: true,
        },
      ];

      return defaultHeaders;
    },
    totalCost() {
      const cost = this.requests.reduce((acc, value) => acc + value.paidPrice, 0);
      return cost;
    },
    requests() {
      const requests = (this.currentUser || {}).requests || [];

      return requests;
    },
  },
  watch: {
    selectedMonth(newValue) {
      this.$router.push({ params: { month: newValue } });
    },
  },
  mounted() {
    this.reportIntervalType = this.intervalTypes[0].value;
  },
  methods: {
    getSoups(dishes) {
      const soups = dishes.filter(d => d.isSoup).map(s => s.title).join(', ');
      return soups || '-';
    },
    getMains(dishes) {
      const mains = dishes.filter(d => !d.isSoup).map(s => s.title).join(', ');
      return mains || '-';
    },
    getDayOfWeek(date) {
      const dayOfWeek = moment(date).format('dddd').toLowerCase();

      return this.$t(`common.${dayOfWeek}`);
    },
  },
  apollo: {
    $loadingKey: 'loading',
    currentUser: {
      fetchPolicy: 'network-only',
      query: gql`query OrdersHistoryQuery($month: TimelessDate!, $intervalType: IntervalType, $languageId: Int) {
        currentUser {
          name: displayName
          requests: requestsForMonth(month: $month, intervalType: $intervalType, showAllCities: true) {
            day {
              cityId
            }
            id
            date
            paidPrice: price(nullifyFreeOfCharge: true)
            dishes {
              isSoup
              title(languageId: $languageId),
            }
          }
        }
      }`,
      variables() {
        return {
          month: this.selectedMonth,
          intervalType: this.reportIntervalType,
          languageId: this.userData.languageId,
        };
      },
      skip() {
        return !this.selectedMonth;
      },
      error(error) {
        this.currentUser = null;
        ErrorHandler.handleApolloError(error);
      },
      result(r) {
        if (!r.loading) {
          NotificationService.clearNetworkNotification();
        }
      },
    },
  },
};
</script>
